import { render, staticRenderFns } from "./individualMember.vue?vue&type=template&id=c79f097c&scoped=true&"
import script from "./individualMember.vue?vue&type=script&lang=js&"
export * from "./individualMember.vue?vue&type=script&lang=js&"
import style0 from "./individualMember.vue?vue&type=style&index=0&id=c79f097c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79f097c",
  null
  
)

export default component.exports